export default "__VITE_ASSET__C7z2GFif__"